import { setOperationStatus, UI_OPERATION_STATUS_ERROR, UI_OPERATION_STATUS_REQUEST, UI_OPERATION_STATUS_SUCCESS } from '@uncinc/react-drupal-core';
import { commerceLoadCart, commerceFetch } from '@uncinc/react-drupal-core/dist/redux/actions/Commerce';
import { setPrevOrderNumber } from '../UI';

export const commerceCartOrderSetAllInformation = (
  billingCountryCode, billingLocality, billingPostalCode, billingAddressLine1, billingAddressLine2, billingGivenName, billingFamilyName, billingOrganization,
  shippingCountryCode, shippingLocality, shippingPostalCode, shippingAddressLine1, shippingAddressLine2, shippingGivenName, shippingFamilyName, shippingOrganization,
  email, invoiceEmail = null, customerReference = null, telephone = null, order_someone_else = false,
) => {
  return (dispatch, getState) => {
    dispatch(setOperationStatus('commerce', 'cart_checkout', UI_OPERATION_STATUS_REQUEST));
    const cartId = getState().getIn(['commerce', 'cart', 'content', 'id']);
    commerceFetch(`checkout/${cartId}`, 'PATCH', {
      type: 'order--default',
      id: cartId,
      attributes: {
        email: email,
        field_invoice_email: invoiceEmail,
        field_customer_reference: customerReference,
        field_order_someone_else: order_someone_else,
        billing_information: {
          address: {
            country_code: billingCountryCode,
            locality: billingLocality,
            postal_code: billingPostalCode,
            address_line1: billingAddressLine1,
            address_line2: billingAddressLine2,
            given_name: billingGivenName,
            family_name: billingFamilyName,
            organization: billingOrganization,
          },
          field_first_name: billingGivenName,
          field_last_name: billingFamilyName,
          field_telephone: telephone,
        },
        shipping_method: '1--default',
        shipping_information: {
          address: {
            country_code: shippingCountryCode,
            locality: shippingLocality,
            postal_code: shippingPostalCode,
            address_line1: shippingAddressLine1,
            address_line2: shippingAddressLine2,
            given_name: shippingGivenName,
            family_name: shippingFamilyName,
            organization: shippingOrganization,
          },
          field_first_name: billingGivenName,
          field_last_name: billingFamilyName,
          field_telephone: telephone,
        },
      },
    }, dispatch, getState)
      .then((response) => {
        if (!(response.status >= 200 && response.status <= 299)) {
          throw new Error(response.status);
        }
        return response.json();
      })
      .then((response) => {
        dispatch(commerceLoadCart());
        dispatch(setOperationStatus('commerce', 'cart_checkout', UI_OPERATION_STATUS_SUCCESS));
      }).catch(() => {
        dispatch(setOperationStatus('commerce', 'cart_checkout', UI_OPERATION_STATUS_ERROR));
      });
  };
};

export const commerceCartApplyCoupon = (couponCode) => {
  return (dispatch, getState) => {
    const cartId = getState().getIn(['commerce', 'cart', 'content', 'id']);
    return commerceFetch(
      `carts/${cartId}/coupons`,
      'PATCH',
      [{ type: 'promotion-coupon', id: couponCode }],
      dispatch,
      getState,
    ).then((response) => {
      if (!response.ok) {
        throw new Error('invalid_coupon');
      }
      // Verify the coupon actually produced a discount (not just added to order).
      // Drupal Commerce returns 200 for expired/used coupons but applies no discount.
      return commerceFetch(
        'carts?include=order_items.purchased_entity.product_id',
        'GET',
        null,
        dispatch,
        getState,
      );
    }).then((response) => {
      if (!response.ok) throw new Error('invalid_coupon');
      return response.json();
    }).then((cartData) => {
      const adjustments = cartData?.data?.[0]?.attributes?.order_total?.adjustments ?? [];
      if (!adjustments.some((adj) => adj.type === 'promotion')) {
        dispatch(commerceCartRemoveCoupon()).catch(() => {});
        throw new Error('invalid_coupon');
      }
      dispatch(commerceLoadCart());
    });
  };
};

export const commerceCartRemoveCoupon = () => {
  return (dispatch, getState) => {
    const cartId = getState().getIn(['commerce', 'cart', 'content', 'id']);
    return commerceFetch(`carts/${cartId}/coupons`, 'DELETE', null, dispatch, getState)
      .then((response) => {
        if (!response.ok) {
          throw new Error('');
        }
        dispatch(commerceLoadCart());
      });
  };
};

export const commerceCartFinishOrder = () => {
  return (dispatch, getState) => {
    dispatch(setOperationStatus('commerce', 'cart_checkout', UI_OPERATION_STATUS_REQUEST));
    const cartId = getState().getIn(['commerce', 'cart', 'content', 'id']);
    commerceFetch(`checkout/${cartId}`, 'PATCH', {
      type: 'order--default',
      id: cartId,
      attributes: {
        state: 'fulfillment',
      },
    }, dispatch, getState).then((response) => {
      // 409 means Drupal already placed this order — a lost response rather
      // than a failure, so treat it as success and let the flow continue.
      if (response.status === 409) {
        dispatch(commerceLoadCart());
        dispatch(setOperationStatus('commerce', 'cart_checkout', UI_OPERATION_STATUS_SUCCESS));
        return null;
      }
      if (!(response.status >= 200 && response.status <= 299)) {
        throw new Error(response.status);
      }
      return response.json();
    }).then((response) => {
      if (!response) {
        return;
      }
      dispatch(setPrevOrderNumber(response.data.attributes.order_number));
      dispatch(commerceLoadCart());
      dispatch(setOperationStatus('commerce', 'cart_checkout', UI_OPERATION_STATUS_SUCCESS));
    }).catch(() => {
      dispatch(setOperationStatus('commerce', 'cart_checkout', UI_OPERATION_STATUS_ERROR));
    });
  };
};
